import React from 'react';

const ScanQr = ({ fillColor = '#FFF', size = '32px', onClick }) => (
  <svg 
    id="b" 
    data-name="Capa 2" 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 211.35 211.35" 
    width={size} 
    height={size} 
    onClick={onClick}
  >
    <g id="c" data-name="OBJECTS">
      <g>
        <path 
          d="M105.68,24.79c0-8.26,0-16.53,0-24.79h16.44v24.79c-5.48,0-10.96,0-16.44,0,0,5.48,0,10.96,0,16.44,5.48,0,10.96,0,16.44,0v33.14h-16.44v30.79h16.44v-16.05l.39-.39h49.19v16.44h23.22v-16.44h16.44v16.7h-16.44c0,5.48,0,10.96,0,16.44-7.74-.01-15.49-.01-23.22,0v16.44h-16.44v-16.44c5.48,0,10.96,0,16.44,0v-16.44h-49.58c0,5.48,0,10.96,0,16.44-5.48,0-10.96,0-16.44,0,0-5.48,0-10.96,0-16.44h-16.44c0,5.48,0,10.96,0,16.44-16,0-32.01,0-48.01,0v-16.44h-24.79v16.44H0v-33.14h41.23v16.44h16.44v-16.05l.39-.39h16.31v16.44h14.87v-47.49h16.44c0-5.48,0-10.96,0-16.44-5.48,0-10.96,0-16.44,0v-16.44c5.48,0,10.96,0,16.44,0Z" 
          fill={fillColor}
        />
        <path 
          d="M105.68,121.85c.01,7.82,0,15.66,0,23.48-5.48,0-10.96,0-16.44,0,.01-7.82,0-15.66,0-23.49,5.48,0,10.96,0,16.44,0Z" 
          fill={fillColor}
        />
        <path 
          d="M122.12,121.85c5.56,0,11.14,0,16.7,0,.01,13.3-.02,26.62,0,39.92-11.04,0-22.1-.02-33.14,0,0,5.48,0,10.96,0,16.44h16.44v16.7h16.7v16.44h-33.14v-32.88h-16.44v-16.7c5.48,0,10.96,0,16.44,0,0-5.48,0-10.96,0-16.44h16.44c0-7.82-.01-15.66,0-23.48Z" 
          fill={fillColor}
        />
        <path 
          d="M194.91,121.85c5.48,0,10.96,0,16.44,0v39.92c-13.22,0-26.45,0-39.66,0v-16.44h23.22c0-7.82-.01-15.66,0-23.48Z" 
          fill={fillColor}
        />
        <path 
          d="M171.69,161.78v16.44h16.31l.39.39v16.31h22.96v16.44h-23.22v-16.44h-16.44v16.44h-16.44v-16.44h16.44v-16.44h-32.88c0-5.56,0-11.14,0-16.7,10.95,0,21.92,0,32.88,0Z" 
          fill={fillColor}
        />
        <path 
          d="M74.37,0v74.37H0V0h74.37ZM57.67,16.44H16.44v41.23h41.23V16.44Z" 
          fill={fillColor}
        />
        <path 
          d="M211.35,0v74.37h-74.37V0h74.37ZM194.91,16.44h-41.23v41.23h41.23V16.44Z" 
          fill={fillColor}
        />
        <path 
          d="M74.37,211.35H0v-74.37h73.97l.39.39v73.97ZM57.67,153.69H16.44v41.23h41.23v-41.23Z" 
          fill={fillColor}
        />
        <rect 
          x="28.96" 
          y="28.96" 
          width="16.44" 
          height="16.44" 
          fill={fillColor} 
        />
        <rect 
          x="165.95" 
          y="28.96" 
          width="16.44" 
          height="16.44" 
          fill={fillColor} 
        />
        <rect 
          x="28.96" 
          y="165.95" 
          width="16.44" 
          height="16.44" 
          fill={fillColor} 
        />
      </g>
    </g>
  </svg>
);

export default ScanQr;
